import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  faDroplet,
  faHome,
  faTemperature0,
  faTemperatureEmpty,
} from "@fortawesome/free-solid-svg-icons";
// import { faCoffee } from '@fortawesome/free-solid-svg-icons';

export interface SummaryData {
  title: string;
  icon: any;
  value: string;
  color?: string;
  chips?:any[]
}
export interface Summary {
  title: string;
  component?: any
  data: SummaryData[];
  iconSize?: string;
  textSize?: string;
}
@Component({
  selector: "app-summary-cards",
  templateUrl: "./summary-cards.component.html",
  styleUrl: "./summary-cards.component.scss",
})
export class SummaryCardsComponent {
  homeIcon = faHome;
  @Output() action = new EventEmitter()

  @Input() summaryCard: Summary[]

  emit(item){
    this.action.emit(item)
  }
}
